import apiClient from './axios';
import axios from 'axios';

// Dashboard
export const fetchAdminDashboard = () => apiClient.get('/admin/dashboard/');

// Users
export const fetchAdminUsers = (params: Record<string, string | number>) =>
  apiClient.get('/admin/users/', { params });

export const fetchAdminUserDetail = (userId: number) =>
  apiClient.get(`/admin/users/${userId}/`);

export const updateAdminUser = (userId: number, data: Record<string, any>) =>
  apiClient.patch(`/admin/users/${userId}/`, data);

export const deleteAdminUser = (userId: number) =>
  apiClient.delete(`/admin/users/${userId}/`);

export const blacklistUser = (userId: number, reason: string) =>
  apiClient.post(`/admin/users/${userId}/blacklist/`, { reason });

export const unblacklistUser = (userId: number) =>
  apiClient.delete(`/admin/users/${userId}/blacklist/`);

// Subscriptions
export const updateSubscription = (userId: number, data: Record<string, any>) =>
  apiClient.patch(`/admin/users/${userId}/subscription/`, data);

// Transactions
export const fetchAdminTransactions = (params: Record<string, string | number>) =>
  apiClient.get('/admin/transactions/', { params });

export const fetchRazorpayOrders = (params: Record<string, string | number>) =>
  apiClient.get('/admin/razorpay-orders/', { params });

export const processRefund = (transactionId: number, reason: string) =>
  apiClient.post(`/admin/refund/${transactionId}/`, { reason });

// Bookings
export const fetchAdminBookings = (params: Record<string, string | number>) =>
  apiClient.get('/admin/bookings/', { params });

export const updateAdminBooking = (bookingId: number, data: Record<string, any>) =>
  apiClient.patch(`/admin/bookings/${bookingId}/`, data);

// Experts
export const fetchAdminExperts = (params: Record<string, string | number>) =>
  apiClient.get('/admin/experts/', { params });

export const verifyExpert = (userId: number, isVerified: boolean) =>
  apiClient.patch(`/admin/experts/${userId}/verify/`, { is_verified: isVerified });

// Wallet
export const adjustWallet = (userId: number, data: Record<string, any>) =>
  apiClient.post(`/admin/wallet/${userId}/adjust/`, data);

// Copilot
export const fetchCopilotStats = () => apiClient.get('/admin/copilot/stats/');

export const resetUserQueries = (userId: number) =>
  apiClient.post(`/admin/users/${userId}/reset-queries/`);

// Email
export const sendAdminEmail = (data: {
  user_ids?: number[];
  send_to_all?: boolean;
  subject: string;
  html_content: string;
}) => apiClient.post('/admin/email/send/', data);

// IP Blacklist
export const fetchBlacklistedIPs = () => apiClient.get('/admin/blacklisted-ips/');

export const addBlacklistedIP = (ip_address: string, reason: string) =>
  apiClient.post('/admin/blacklisted-ips/', { ip_address, reason });

export const removeBlacklistedIP = (id: number) =>
  apiClient.delete(`/admin/blacklisted-ips/${id}/`);

// Support Tickets
export const fetchSupportTickets = (params: Record<string, string | number>) =>
  apiClient.get('/admin/support-tickets/', { params });

export const updateSupportTicket = (ticketId: number, data: Record<string, any>) =>
  apiClient.patch(`/admin/support-tickets/${ticketId}/`, data);

// Audit Log
export const fetchAuditLog = (params: Record<string, string | number>) =>
  apiClient.get('/admin/audit-log/', { params });

// Buckets
export const fetchAdminBuckets = (params: Record<string, string | number>) =>
  apiClient.get('/admin/buckets/', { params });

export const createAdminBucketStock = (data: Record<string, any>) =>
  apiClient.post('/admin/buckets/', data);

export const updateAdminBucketMeta = (bucketName: string, data: Record<string, any>) =>
  apiClient.patch(`/admin/buckets/${encodeURIComponent(bucketName)}/`, data);

export const deleteAdminBucket = (bucketName: string) =>
  apiClient.delete(`/admin/buckets/${encodeURIComponent(bucketName)}/`);

export const fetchAdminBucketStocks = (bucketName: string, params: Record<string, string | number>) =>
  apiClient.get(`/admin/buckets/${encodeURIComponent(bucketName)}/stocks/`, { params });

export const updateAdminBucketStock = (stockId: number, data: Record<string, any>) =>
  apiClient.patch(`/admin/buckets/stocks/${stockId}/`, data);

export const deleteAdminBucketStock = (stockId: number) =>
  apiClient.delete(`/admin/buckets/stocks/${stockId}/`);

// Company Insights
export const searchAdminCompanies = (q: string) =>
  apiClient.get('/admin/companies/search/', { params: { q } });

export const fetchAdminCompanyInsights = (companyName: string) =>
  apiClient.get(`/admin/companies/${encodeURIComponent(companyName)}/`);

export const updateAdminCompanyInsights = (companyName: string, data: Record<string, any>) =>
  apiClient.patch(`/admin/companies/${encodeURIComponent(companyName)}/`, data);

// LLM Configs (served by MCP server, not FastAPI)
const MCP_BASE = process.env.REACT_APP_MCP_API_URL?.replace('/call', '') || 'https://core.yantrai.com/mcp';

export const fetchAdminLLMConfigs = () =>
  axios.get(`${MCP_BASE}/api/admin/llm-configs`);

export const createAdminLLMConfig = (data: Record<string, any>) =>
  axios.post(`${MCP_BASE}/api/admin/llm-configs/create`, data);

export const updateAdminLLMConfig = (id: number, data: Record<string, any>) =>
  axios.post(`${MCP_BASE}/api/admin/llm-configs/${id}/update`, data);

export const deleteAdminLLMConfig = (id: number) =>
  axios.post(`${MCP_BASE}/api/admin/llm-configs/${id}/delete`);

// Embedding Configs (served by MCP server)
export const fetchAdminEmbeddingConfigs = () =>
  axios.get(`${MCP_BASE}/api/admin/embedding-configs`);

export const createAdminEmbeddingConfig = (data: Record<string, any>) =>
  axios.post(`${MCP_BASE}/api/admin/embedding-configs/create`, data);

export const updateAdminEmbeddingConfig = (id: number, data: Record<string, any>) =>
  axios.post(`${MCP_BASE}/api/admin/embedding-configs/${id}/update`, data);

export const deleteAdminEmbeddingConfig = (id: number) =>
  axios.post(`${MCP_BASE}/api/admin/embedding-configs/${id}/delete`);

export const activateAdminEmbeddingConfig = (id: number) =>
  axios.post(`${MCP_BASE}/api/admin/embedding-configs/${id}/activate`);
